import React, { useRef } from "react";
import { Button } from "@/components/ui/button";
import { API } from "@/lib/api";
import { Upload, Download } from "lucide-react";
import { toast } from "sonner";

/** Reusable Excel import + template download buttons. */
export const ExcelImportButtons = ({ endpoint, templateEndpoint, filename, onDone, testidPrefix = "import" }) => {
  const ref = useRef();

  const downloadTemplate = () => {
    const token = localStorage.getItem("spbu_token");
    fetch(`${API}${templateEndpoint}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.blob()).then((b) => {
        const url = URL.createObjectURL(b);
        const a = document.createElement("a"); a.href = url; a.download = filename; a.click();
      });
  };

  const onChange = async (e) => {
    const f = e.target.files?.[0]; if (!f) return;
    const fd = new FormData(); fd.append("file", f);
    const token = localStorage.getItem("spbu_token");
    const outlet = localStorage.getItem("spbu_active_outlet") || "default";
    try {
      const res = await fetch(`${API}${endpoint}`, {
        method: "POST", body: fd,
        headers: { Authorization: `Bearer ${token}`, "X-Outlet-Id": outlet },
      });
      const d = await res.json();
      if (!res.ok) throw new Error(d.detail || "Gagal");
      toast.success(`Import selesai: ${d.created} baris masuk${d.skipped?.length ? `, ${d.skipped.length} skip` : ""}`);
      if (d.skipped?.length) console.warn("Import skipped:", d.skipped);
      onDone && onDone();
    } catch (err) { toast.error(err.message); }
    e.target.value = "";
  };

  return (
    <div className="flex gap-2">
      <Button variant="ghost" size="sm" onClick={downloadTemplate} data-testid={`${testidPrefix}-template`}>
        <Download className="w-4 h-4 mr-2" />Template
      </Button>
      <input type="file" accept=".xlsx" className="hidden" ref={ref} onChange={onChange} data-testid={`${testidPrefix}-file`} />
      <Button variant="outline" onClick={() => ref.current?.click()} data-testid={`${testidPrefix}-button`}>
        <Upload className="w-4 h-4 mr-2" />Import Excel
      </Button>
    </div>
  );
};
